import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
  useEffect(() => {
    // Smooth scrolling for hash links
    const handleHashLinks = (e) => {
      if (e.target.getAttribute('href')?.startsWith('#')) {
        e.preventDefault();
        const target = document.querySelector(e.target.getAttribute('href'));
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };

    // Parallax effect
    const handleScroll = () => {
      const scrolled = window.pageYOffset;
      const heroVisual = document.querySelector('.hero-visual');
      if (heroVisual) {
        heroVisual.style.transform = `translateY(${scrolled * 0.3}px)`;
      }
    };

    document.addEventListener('click', handleHashLinks);
    window.addEventListener('scroll', handleScroll);

    return () => {
      document.removeEventListener('click', handleHashLinks);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="landing-page">
      <header>
        <nav className="container">
          <div className="logo">ENRY</div>
          <ul className="nav-links">
            <li><Link to="/demo">Demo</Link></li>
            <li><a href="#features">Features</a></li>
            <li><a href="#partnerships">Partners</a></li>
            <li><Link to="/login">Login</Link></li>
          </ul>
        </nav>
      </header>

      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>Revolutionize Student Tracking</h1>
              <p className="subtitle">Lightning-fast mentor-mentee interaction recording</p>
              <p>Optimize speed & convenience of recording events across all domains of student interaction. Transform required compliance tracking into practical engagement that heightens effectiveness and personal connection.</p>
              
              <div className="cta-buttons">
                <Link to="/demo" className="btn btn-primary">Try Live Demo</Link>
                <Link to="/login" className="btn btn-secondary">Sign In</Link>
              </div>
            </div>
            
            <div className="hero-visual">
              <div className="classroom-scene">
                <div className="student-profiles">
                  {/* Student profile cards */}
                  {['Alex M.', 'Sarah K.', 'Mike R.', 'Emma L.', 'Josh T.', 'Maya P.'].map((name, index) => (
                    <div key={name} className="profile-card">
                      <div className="profile-avatar"></div>
                      <div className="profile-name">{name}</div>
                      <div className="progress-bar">
                        <div className="progress-fill" style={{width: `${45 + index * 10}%`}}></div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="teacher-silhouette"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features" id="features">
        <div className="container">
          <h2>Built for Educators, By Educators</h2>
          <div className="features-grid">
            {featuresData.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <footer>
        <div className="container">
          <div className="footer-links">
            <Link to="/demo">Live Demo</Link>
            <Link to="/login">Sign In</Link>
            <a href="#partnerships">Partnerships</a>
            <a href="#support">Support</a>
          </div>
          <p>&copy; 2025 ENRY. Empowering educators through intelligent tracking.</p>
        </div>
      </footer>
    </div>
  );
};

const featuresData = [
    {
        icon: '⚡',
        title: 'Lightning Fast Recording',
        description: 'Record student interactions in seconds, not minutes. Optimize your time for what matters most - teaching.'
    },
    {
        icon: '📊',
        title: 'Progress Tracking',
        description: 'Visualize student growth with intuitive dashboards. Meet compliance requirements effortlessly.'
    },
    {
        icon: '🤝',
        title: 'Personal Connection',
        description: 'Strengthen mentor-mentee relationships through data-driven insights and meaningful interactions.'
    },
    {
        icon: '🎯',
        title: 'Multi-Tiered Support',
        description: 'Seamlessly integrate with existing MTSS frameworks and intervention protocols.'
    },
    {
        icon: '📱',
        title: 'Mobile Ready',
        description: 'Access from any device, anywhere. Perfect for busy educators on the go.'
    },
    {
        icon: '🔒',
        title: 'Secure & Compliant',
        description: 'Built with privacy and security in mind. Meet all educational data protection standards.'
    }
    ];
  

export default LandingPage; 